import { render, staticRenderFns } from "./LeavePayrollLog.vue?vue&type=template&id=645b30a6"
import script from "./LeavePayrollLog.vue?vue&type=script&lang=js"
export * from "./LeavePayrollLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports